import {
  PayeeRequirement,
  RequirementStatus,
  SignatureRequest,
  SignerStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * TODO(v3-verify): v1 read a top-level `events.payeeSignedAt` flag on the
 * signed document. v3's `SignatureRequest` only carries per-signer status —
 * matching the payee's signer via `role === "Payee"` assumes the BE keeps
 * the same string convention as v1's `SignerRole` enum; confirm at runtime
 * (same open question as `ESignatureWidget`).
 */
export const selectorIsRequirementReadyToSignAsPayee = (
  requirement: PayeeRequirement,
  document?: SignatureRequest
): boolean => {
  const payeeSigner = document?.signers?.find(
    signer => signer.role === "Payee"
  );
  const isSignedByPayee = payeeSigner?.status === SignerStatus.SIGNED;

  return (
    !!document &&
    requirement.dataSourceStatus !== RequirementStatus.COMPLETED &&
    !isSignedByPayee
  );
};
